const button = {
  textTransform: 'none',
  borderRadius: '2em',
  minWidth: '160px',
  padding: '10px 20px',
  margin: '10px 20px 20px 0',
  fontSize: '1rem',
  boxShadow: 'none',
};

export const styles = {
  dialog: {
    '& .MuiDialog-paper': {
      padding: '2em',
      minWidth: '500px',
    },
  },
  formControl: {
    margin: '1em 0',
  },
  uploadButton: {
    marginBottom: '1em',
    textTransform: 'none',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '1em',
    marginTop: '2em',
  },
  button: button,
  cancelButton: {
    ...button,
    backgroundColor: (theme) => theme.palette.baseColors.gray.c100,
  },
};